import { Component, ChangeDetectionStrategy } from '@angular/core';

import { BtnActionComponent } from '../btn-action/btn-action.component';

@Component({
    selector: 'aa-btn-action-quaternary',
    templateUrl: '../btn-action/btn-action.component.html',
    styleUrls: [
        '../btn-action/btn-action.component.scss',
        './btn-action-quaternary.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BtnActionQuaternaryComponent extends BtnActionComponent
{
    constructor ()
    {
        super();
    }
}
